import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        overview : {},
    },
    getters: {
        getOverview: state => state.overview,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setOverView(state, { resp }){
            if (resp) {
                state.overview = resp.data.data
            }
        }
    },
    actions: {
        getOverview({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/home/get-overview?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setOverView', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteStatus({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/home/delete-status?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
